import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';
import { UserRole } from '../../types/permissions';

interface PermissionWrapperProps {
  permission: UserRole;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  requireAll?: boolean; // If true, user must have exact role, not just sufficient permissions
}

export const PermissionWrapper: React.FC<PermissionWrapperProps> = ({
  permission,
  children,
  fallback = null,
  requireAll = false,
}) => {
  const { hasPermission, userRole } = usePermissions();
  
  const hasRequiredPermission = requireAll 
    ? userRole === permission 
    : hasPermission(permission);
  
  if (!hasRequiredPermission) {
    return <>{fallback}</>;
  }
  
  return <>{children}</>;
};
